import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const body = css`
  background: transparent;
  padding-block-end: ${spacing(4.25)};
  padding-bottom: 0;
`

export const closeIcon = css`
  color: ${cssTheme.default.day.textInvert};
`

export const texts = css`
  padding: ${spacing(0, 6, 0, 2)};
`

export const image = css`
  flex: 1;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;

  @media (max-height: 600px) {
    display: none;
  }
`

export const buttons = css`
  padding: ${spacing(1)};
  margin-top: auto;
`

export const defaultButton = css`
  ${cssTheme.default.day.controlMinor.token}: #F5F4F21A;
  ${cssTheme.components.buttons.default.bgColorHovered.token}: #0000000D;
  ${cssTheme.components.buttons.default.bgColorPressed.token}: #0000001A;
`
